import Vue from 'vue'
import Router from 'vue-router'
import Map from '@/components/Map'
// import TemporalFilter from '@/components/TemporalFilter'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    components: {
      'Map': Map
      //   'TemporalFilter': TemporalFilter
    }
  }],
  // mode: 'history' // enable relative paths deployment, e.g., in subfolders.
})



// WEBPACK FOOTER //
// ./src/router/index.js